module.exports = __webpack_public_path__ + "img/check-mark.56963fcc.png";